<template>
    <div class="reward">
        <div class="tableConBox">
            <div class="tableTem" @click="searchList=[]">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="title" style="width:100px">租赁汇总</div>
                    <div class="searchCon clearfix">
                        <div class="month-filter" v-if="nowType=='month'&&searchByWhichType=='dayOrMonth'">
                            <el-date-picker
                            v-model="valueForMonth"
                            value-format="yyyy-MM"
                            format="yyyy 年 MM 月"
                            :picker-options="pickerOptions0"
                            type="month"
                            class="dateTime"
                            placeholder="选择月">
                            </el-date-picker>
                        </div>
                        <div class="time-range-filter" v-if="nowType=='day'&&searchByWhichType=='dayOrMonth'">
                            <el-date-picker
                            v-model="form.beginTime"
                            @change="$forceUpdate()"
                            type="datetime"
                            class="dateTime"
                            default-time="00:00:00"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="form.endTime"
                            @change="$forceUpdate()"
                            type="datetime"
                            class="dateTime"
                            default-time="23:59:59"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="结束时间">
                            </el-date-picker>
                        </div>
                        <div class="day-filter" v-if="nowType=='day'&&searchByWhichType=='dayOrMonth'">
                            <!-- <el-input type="text" size="small" v-model="form.mobile" placeholder="请输入手机号查询"/> -->
                            <!-- <el-date-picker
                            v-model="nowDay"
                            type="date"
                            placeholder="选择日期"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd"
                            class="dateTime"
                            :picker-options="pickerOptionsForDay"
                            >
                            </el-date-picker> -->
                        </div>
                        <div class="time-range-filter" v-if="searchByWhichType=='timeRange'">
                            <el-date-picker
                            v-model="startTime"
                            type="datetime"
                            class="dateTime"
                            default-time="00:00:00"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="endTime"
                            type="datetime"
                            class="dateTime"
                            default-time="23:59:59"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="结束时间">
                            </el-date-picker>
                        </div>
                        <span class="types typesSearch">
                            <!-- 员工：
                            <el-select v-model="judge" placeholder="请选择">
                                <el-option
                                :key="0"
                                label="全部"
                                value="ALL">
                                </el-option>
                                <el-option
                                v-for="item in tableList"
                                :key="item.value"
                                :label="item.empName"
                                :value="item.empId">
                                </el-option>
                            </el-select> -->
                        </span>
                        <span class="types typesSearch">
                            <span type="button" @click="searchConfirm">查询</span>
                        </span>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:5%">序号</th>
                                <th style="width:10%">商品名称</th>
                                <th style="width:10%">使用时长</th>
                                <th style="width:10%">实收金额</th>
                            </tr>
                        </table>
                        <div class="scrollBox"  v-if="nowType=='day'&&searchByWhichType=='dayOrMonth'">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:tableList.length>10}" v-if="tableList.length>0">
                                    <tr v-for="(item,ind) in tableList" :key="ind">
                                        <td style="width:5%" >
                                            <span v-text="ind+1" ></span>
                                        </td>
                                        <td style="width:10%;" :title="item.name" v-text="item.name"></td>
                                        <td style="width:10%;" :title="item.time" v-text="item.time"></td>
                                        <td style="width:10%;" :title="item.amount" v-text="item.amount"></td>
                                    </tr>
                                </table>
                                <div class="no-data" v-else>
                                    暂无记录，请点击查询或者重新选择查询条件。
                                </div>
                            </div>
                        </div>
                        <div class="tableBox scrollBox tableBox-for-month" v-if="nowType=='month'&&searchByWhichType=='dayOrMonth'">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:tableList.length>10}" v-if="tableList.length>0">
                                    <tr v-for="(item,ind) in tableList" :key="ind">
                                        <td style="width:5%" >
                                            <span v-text="ind+1" ></span>
                                        </td>
                                        <td style="width:10%;" v-text="item.numName"></td>
                                        <td style="width:10%;" v-text="item.productName"></td>
                                        <td style="width:15%;" v-text="item.ruleName"></td>
                                        <td style="width:10%;" v-text="item.mobile"></td>
                                        <td style="width:10%;">快乐；kll</td>
                                        <td style="width:10%;">{{item.totalAmount | toFixedNum}}</td>
                                        <td style="width:10%;">{{item.payAmount | toFixedNum}}</td>
                                        <td style="width:10%;">{{item.getAmount | toFixedNum}}</td>
                                        <td style="width:10%;">{{item.refundAmount | toFixedNum}}</td>
                                    </tr>
                                </table>
                                <div class="no-data" v-else>
                                    暂无记录，请点击查询或者重新选择查询条件。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分页器 -->
                <!-- <div class="pager flex flex-align-center" v-if="nowType=='day'&&searchByWhichType=='dayOrMonth'">
                    <div class="pagerCon clearfix">
                        <span class="left item">数量:<span class="num color3" v-text="allQty"></span></span>
                        <span class="left item">总收入:<span class="num color5">{{allAmount | toFixedNum}}</span></span>
                    </div>
                </div> -->
                <!-- <div class="pager flex flex-align-center" v-if="nowType=='month'&&searchByWhichType=='dayOrMonth'">
                    <div class="pagerCon clearfix">
                        <span class="left item">数量:<span class="num color3" v-text="allQtyForMonth"></span></span>
                        <span class="left item">总收入:<span class="num color5">{{allAmountForMonth | toFixedNum}}</span></span>
                    </div>
                </div> -->
                <div class="pager flex flex-align-center" v-if="false">
                    <div class="pagerCon clearfix" >
                        <span class="left item">总押金:<span class="num color3">{{ totalInfo.totalAmount | toFixedNum }}</span></span>
                        <span class="left item">实收:<span class="num color2">{{ totalInfo.getAmount | toFixedNum }}</span></span>
                        <span class="left item">退回押金:<span class="num color5">{{totalInfo.refundAmount | toFixedNum}}</span></span>
                    </div>
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:(curPage>0)}" @click="changePage(false)"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(curPage+1)"></span>
                                <span class="next flex flex-align-center flex-pack-center left" :class="{havePage:((curPage+1)<totalPage)}" @click="changePage(true)"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right" v-text="'第 '+(curPage+1)+' / '+totalPage+' 页'"></div>
                        <div class="totalPage flex flex-align-center right" v-text="'共'+totalElements+'条'"></div>
                    </div>
                </div>
            </div>
        </div>
        <table id="scrollBox" style="display:none"> 
        </table>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {BASE_URL,API_BASE_URL} from "../../../../urlConfig/index";
    export default{
        props:['curStoreId'],
        data () {
            return {
                pageSize:20,
                clickBtn:true,
                totalInfo:{
                    totalAmount:0,
                    getAmount:0,
                    refundAmount:0,
                },
                startTime:"",
                endTime:"",
                form:{
                    mobile:"",
                    beginTime:"",
                    endTime:"",
                },
                canClick:true,
                pickerOptionsForTimeRange: {
                    //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() > Date.now() || time.getTime() < (new Date('2017,01,01')).getTime();
                    }
                },
                judge:"ALL",
                tableList:[],//员工列表
                searchByWhichType:"dayOrMonth",//按照时间段或者是按月份。按日的形式查询，dayOrMonth,timeRange，时间段暂时没有
                valueForMonth:'',//月份信息
                allAmount:0,//总金额
                allQtyForMonth:0,//按月份总数量
                allAmountForMonth:0,
                allQty:0,//总数量
                nowDay:'',//当前日期
                nowType:"day",//当前查询方式，如日报，按月份
                rewardDataForMonth:[],
                getBtn: true, // 控制翻页请求
                pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                
                pickerOptionsForDay: {
                //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                
                timeFrom:'',//开始时间
                timeTo:'',//截止时间
                searchList: [], // 搜索结果数组
                goodSearchBtn: true, // 控制搜索框
                canSearch: true, //
                options:[],
                curPage: 0,//当前页，用于切换页码
                totalPage: 1,//总共页
                totalElements: 0,//总共条
            }
        },
        methods: {
            spanTime(start,end){
                if(start && end){
                    let spanTime = new Date(end).getTime() - new Date(start).getTime();
                    let hour = 60 * 1000 * 60;
                    let min = 60 * 1000;
                    let sec = 1000;
                    let hours = Math.floor(spanTime / hour);
                    let mins = Math.ceil((spanTime % hour) / min);
                    if (hours < 0) {
                        return `0小时0分`;
                    }
                    return `${hours}小时${mins}分`;
                }else{
                    let spanTime = new Date().getTime() - new Date(start).getTime();
                    let hour = 60 * 1000 * 60;
                    let min = 60 * 1000;
                    let sec = 1000;
                    let hours = Math.floor(spanTime / hour);
                    let mins = Math.ceil((spanTime % hour) / min);
                    if (hours < 0) {
                        return `0小时0分`;
                    }
                    return `${hours}小时${mins}分`;
                }
            },
            // 搜索
            searchConfirm: function () {
                if(this.form.mobile){
                    if ( !(/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.form.mobile)) ) {
                        this.$message({
                            message:"请输入正确的手机号",
                            customClass: "error"
                        });
                        return;   
                    }
                }
                if(this.form.beginTime && this.form.endTime){
                    if(new Date(this.form.endTime).getTime() < new Date(this.form.beginTime).getTime()){
                        this.$message({
                            message:"结束时间必须大于开始时间",
                            customClass: "error"
                        });
                        return;
                    }
                }
                if(!this.form.beginTime && this.form.endTime || (this.form.beginTime && !this.form.endTime)){
                    this.$message({
                        message:"请完整选择开始时间和结束时间",
                        customClass: "error"
                    });
                    return;
                }
                this.getData();
            },
            getRewardData(date,source,judge){
                let params;
                if(this.searchByWhichType === "dayOrMonth"){
                    if(source=="DAY"){
                        params = {
                            storeId:this.curStoreId,
                            from:date,
                            type:"STORE",
                            source,
                            judge
                        }
                        // 
                        let timeStr = new Date(date).getTime() + "-"+judge+"-" + new Date(date).getTime();
                        let nowTime = new Date().getTime();
                        if(!(this.$canClickSelect("rewardInfoDay",timeStr,nowTime))){
                            this.$message({
                                message: '5秒内禁止重复查询相同数据',
                                customClass: 'error'
                            });
                            return;
                        }
                        //
                    }else{
                        params = {
                            storeId:this.curStoreId,
                            year:date.year,
                            month:date.month,
                            type:"STORE",
                            source,
                            judge
                        }
                        // 
                        let timeStr = new Date(date.year+"-"+date.month+"-01").getTime() + "-"+judge+"-" + new Date(date.year+"-"+date.month+"-01").getTime();
                        let nowTime = new Date().getTime();
                        if(!(this.$canClickSelect("rewardInfoMonth",timeStr,nowTime))){
                            this.$message({
                                message: '5秒内禁止重复查询相同数据',
                                customClass: 'error'
                            });
                            return;
                        }
                        //
                    }
                }
                this.$http({
                    url:API_BASE_URL+"v1/clerk/get-reward",
                    method:"GET",
                    params
                }).then(res=>{
                    console.log(res);
                    if(this.searchByWhichType === "dayOrMonth"){
                        if(source == "DAY"){
                            this.tableList = res.data.rews;
                            this.allAmount = res.data.total;
                            this.allQty = res.data.count;
                        }else{
                            this.rewardDataForMonth = res.data.rews;
                            this.allAmountForMonth = res.data.total;
                            this.allQtyForMonth = res.data.count; 
                        }
                    }
                });
            },
            changePage: function ( boo ) {
                if(!this.clickBtn){
                    return;
                }
                this.clickBtn = false;
                this.curCheckArr = [];
                this.allCheckArr = false;
                setTimeout(()=>{
                     this.clickBtn = true;
                },800)
                if ( boo ) {
                    if ( (this.curPage + 1) >= this.totalPage ) {
                        return;
                    }
                    this.curPage++;
                } else {
                    if ( this.curPage <= 0 ) {
                        return;
                    }
                    this.curPage--;
                }
                this.getData();
            },
            // 获取员工列表
            getData(){
                if(!this.canClick){
                    return;
                }
                this.canClick = false;
                this.$http({
                    url:"sum/lease",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        // mobile:this.form.mobile,
                        // size:this.pageSize,
                        // page:this.curPage,
                        begin:this.form.beginTime ? new Date(this.form.beginTime).Format("yyyy-MM-dd hh:mm:ss"):undefined,
                        end:this.form.endTime ? new Date(this.form.endTime).Format("yyyy-MM-dd hh:mm:ss"):undefined,
                    }
                }).then(res=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                    this.tableList = res.data;
                    if(res.data && res.data.hasOwnProperty("result") && res.data.result){
                        this.totalInfo = res.data.result;
                    }
                    // this.totalElements = res.data.totalElements;
                    // this.totalPage = res.data.totalPages;
                }).catch(err=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                });
            }
        },
        activated: function () {
            this.nowDay = new Date();
            this.valueForMonth = new Date();
            this.form.beginTime = new Date().Format("yyyy-MM-dd 00:00:00");
            this.form.endTime = new Date().Format("yyyy-MM-dd 23:59:59");
            this.$forceUpdate();
            this.getData();
        }
    }
</script>
<style lang="scss">
    @import '../../../../../static/css/common.scss';
    @import '../../../tableTemplate/tableTem.scss';
    @import "./rentDetail.scss";
</style>



// WEBPACK FOOTER //
// rentDetail.vue?31863c24